<template>
  <div class="options-list-input">
    <header class="options-list-input__text">
      {{ label }}
    </header>

    <section class="options-list-input__options">
      <label
        class="options-list-input__option"
        :class="`options-list-input__option--${option.value}`"
        v-for="option in options"
        :key="option.value"
      >
        <input
          type="checkbox"
          class="options-list-input__input"
          :name="name"
          :value="option.value"
          v-model="selectedValues"
          @change="onChange"
        >
        <!-- :type="multiple ? 'checkbox' : 'radio'"  /// see todo-->
        <span class="options-list-input__label">
          <slot
            :option="option"
            :selected="isSelected(option)"
          >
            <span class="options-list-input__label-text">{{ option.label }}</span>
          </slot>
        </span>
      </label>
    </section>

    <transition name="input-error--animation">
      <div
        class="options-list-input__error | input-error"
        v-if="!!error"
        v-html="error"
      />
    </transition>
  </div>
</template>


<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';

  @Options({
    name: 'options-list-input',
  })
  export default class voteInput extends Vue {
    @Prop({required: true})
    name: string;

    @Prop({required: true})
    options: {label: string, value: string}[];

    @Prop()
    label: string;

    @Prop({default: false})
    multiple!: boolean;

    @Prop()
    value: string[];

    @Prop()
    error: string;

    selectedValues: string|string[] = this.multiple ? [] : '';

    onChange() {
      this.$emit('update:modelValue', this.selectedValues);
    }

    isSelected(option: {label: string, value: string}): boolean {
      return this.selectedValues.indexOf(option.value) > -1;
    }
  }
</script>
